export default __webpack_public_path__ + "static/media/dolphins_1.c5bae4c0.jpg";